import {
    useTheme,
    Box,
} from '@mui/material';

const Loader = ({ boxMinHeight, loaderSize }) => {
    const theme = useTheme();
    return (
        <Box sx={{ 
            display: 'flex', justifyContent: 'center',
            alignItems: 'center', minHeight: boxMinHeight, width: '100%', 
        }}>
            <div 
                className="loader" 
                style={{ 
                    borderRightColor: theme.palette.primary.main,
                    width: `${loaderSize}px`, 
                }}
            />
        </Box>
    );
}

Loader.defaultProps = {
    boxMinHeight: '250px',
    loaderSize: 50,
}

export default Loader;